import React from 'react';
import { Link } from 'react-router-dom';
import '../estilo.css';

export default function Inicio() {
  return (
    <div>
      {/* HERO / TOPO */}
      <div className="hero-banner">
        <img
          src={require('../img/Imagem_inicial.png')}
          alt="Quantum Trades"
          className="hero-banner-image"
        />

      </div>
      <div
        className="jumbotron text-center legacy-hero"
        style={{
          background:
            'radial-gradient(circle at top, #61527a 0%, #443c56 52%, #322943 100%)',
          padding: '80px 20px 70px',
        }}
      >
        <div style={{ maxWidth: '1120px', margin: '0 auto' }}>
          <div className="row" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <div className="col-sm-6" style={{ marginBottom: '20px' }}>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '8px 14px',
                  borderRadius: '999px',
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.12)',
                  color: '#d7fff7',
                  fontSize: '13px',
                  fontWeight: 700,
                  letterSpacing: '0.3px',
                  marginBottom: '20px',
                }}
              >
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: '#42a89c',
                    boxShadow: '0 0 10px rgba(66,168,156,0.6)',
                  }}
                />
                Ecossistema Quantum Trades para MetaTrader 5
              </div>

              <h1
                style={{
                  fontSize: '46px',
                  lineHeight: 1.1,
                  margin: '0 0 14px 0',
                  color: '#ffffff',
                  textAlign: 'left',
                }}
              >
                Quantum Trades
              </h1>

              <h3
                style={{
                  fontSize: '24px',
                  fontWeight: 500,
                  color: '#d8d1ff',
                  margin: '0 0 20px 0',
                  textAlign: 'left',
                }}
              >
                Três robôs, mais possibilidades de operação, análise e diversificação.
              </h3>

              <p
                style={{
                  maxWidth: '620px',
                  margin: 0,
                  fontSize: '17px',
                  lineHeight: 1.7,
                  color: '#f3f1ff',
                  textAlign: 'left',
                  paddingTop: 0,
                }}
              >
                A Quantum Trades reúne soluções diferentes para perfis diferentes de trader:
                o <strong>Quantum Trades EA</strong> para automação avançada e flexível,
                o <strong>QuantumTrades Bias</strong> para leitura de viés e direção de mercado,
                e o <strong>QuantumTrades Ragnarok</strong> para operações mais rápidas scalp.
              </p>

              <p
                style={{
                  maxWidth: '620px',
                  marginTop: '14px',
                  fontSize: '15px',
                  lineHeight: 1.7,
                  color: '#e5ddff',
                  textAlign: 'left',
                }}
              >
                Use robôs individuais ou combine estratégias para buscar mais equilíbrio,
                mais controle operacional e uma estrutura mais diversificada dentro do MT5.
              </p>

              <div
                style={{
                  marginTop: '26px',
                  display: 'flex',
                  gap: '12px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <Link to="/cadastro" className="btn btn-primary btn-lg">
                  Criar minha conta
                </Link>
                <Link to="/planos" className="btn btn-default btn-lg">
                  Ver planos e simular
                </Link>
              </div>

              <div
                style={{
                  marginTop: '22px',
                  display: 'flex',
                  gap: '22px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>3</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>Robôs disponíveis</div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>MT5</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>Compatível com MetaTrader 5</div>
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ color: '#42a89c', fontSize: '24px', fontWeight: 800 }}>Forex + Ouro</div>
                  <div style={{ color: '#d8d1ff', fontSize: '13px' }}>Estratégias para cenários diferentes</div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 text-center">
              <div
                style={{
                  position: 'relative',
                  maxWidth: '500px',
                  margin: '0 auto',
                  padding: '26px',
                  borderRadius: '28px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.10)',
                  boxShadow:
                    '0 24px 60px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.06)',
                  backdropFilter: 'blur(6px)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    inset: '18px',
                    borderRadius: '22px',
                    background:
                      'radial-gradient(circle at top right, rgba(66,168,156,0.14), transparent 42%), radial-gradient(circle at bottom left, rgba(132,110,143,0.18), transparent 40%)',
                    pointerEvents: 'none',
                  }}
                />

                <div
                  style={{
                    position: 'relative',
                    borderRadius: '22px',
                    padding: '18px',
                    background: 'linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))',
                  }}
                >
                  <img
                    src={require('../img/Quantum1.png')}
                    alt="Quantum Trades"
                    className="responsive-image"
                    style={{
                      maxWidth: '100%',
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                      borderRadius: '18px',
                      boxShadow: '0 14px 35px rgba(0,0,0,0.22)',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="robos" className="robots-section">
        <div className="robots-inner">
          <div className="robots-header">
            <p>Nossos Robos</p>
            <h2>Automacoes para perfis e estrategias diferentes</h2>
            <div className="robots-intro">
              A Quantum Trades reune solucoes diferentes para perfis diferentes de trader,
              combinando automacao, leitura de mercado e estrategias configuraveis dentro do MT5.
            </div>
          </div>

          <div className="robots-grid">
            <article className="robot-card">
              <h3>QuantumTrades Bias</h3>
              <p>
                Robo automatizado para MetaTrader 5 com foco em leitura de direcao e forca do
                mercado. Opera com estrategias configuraveis de compra, venda ou ambos os lados,
                usando filtros tecnicos, gerenciamento por ciclos e reentradas.
              </p>
              <ul>
                <li>Leitura de forca e direcao do mercado</li>
                <li>Estrategias separadas por compra e venda</li>
                <li>Indicador integrado e painel visual</li>
                <li>Arquivos .set prontos para uso</li>
              </ul>
            </article>

            <article className="robot-card">
              <h3>QuantumTradesIA</h3>
              <p>
                Robo automatizado para MetaTrader 5 com estrategia Open Box e gerenciamento
                inteligente de ciclos operacionais. Permite operar diferentes ativos com maior
                liberdade de configuracao e controle sobre a estrategia.
              </p>
              <ul>
                <li>Estrategia Open Box</li>
                <li>Compatibilidade com diferentes mercados</li>
                <li>Entradas, reentradas e preco medio</li>
                <li>Take profit, trailing stop e protecoes</li>
              </ul>
            </article>

            <article className="robot-card">
              <h3>QuantumTrades Ragnarock</h3>
              <p>
                Robo automatizado para MetaTrader 5 com foco em gestao de ciclos, reentradas e
                controle operacional avancado. Foi criado para automatizar o acompanhamento da
                posicao desde a entrada ate o encerramento.
              </p>
              <ul>
                <li>Gestao de ciclos operacionais</li>
                <li>Compra, venda ou ambos os lados</li>
                <li>Reentradas e preco medio</li>
                <li>Painel visual e arquivos .set prontos</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* SEÇÃO SOBRE / ID PARA O MENU */}
      <div id="about" className="container-fluid bg-quant">
        <div className="about-shell">
          <div className="about-intro">
            <h2>O que é a Quantum Trades?</h2>
            <p>
              A <strong>Quantum Trades</strong> é um ecossistema de robôs para MetaTrader 5,
              desenvolvido para oferecer automação, leitura de mercado e apoio à execução de
              estratégias operacionais.
            </p>

            <p>
              A plataforma conta com diferentes soluções automatizadas, permitindo que cada
              trader escolha o modelo mais adequado ao seu perfil, rotina operacional, tamanho
              de conta e mercado de atuação.
            </p>

            <p>
              Em vez de depender de uma única abordagem, a Quantum Trades oferece um conjunto
              diversificado de ferramentas. O usuário pode utilizar um robô específico, combinar
              estratégias ou montar um pacote completo com soluções complementares para análise,
              execução e gerenciamento das operações.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-block">
            <h3>Nossa missão</h3>
            <p>
              A Quantum Trades nasceu com a proposta de tornar a automação no mercado financeiro
              mais acessível, organizada e profissional.
            </p>

            <p>
              Nosso foco não é vender promessas irreais, mas oferecer ferramentas que ajudem o
              trader a estruturar melhor sua operação, reduzir decisões impulsivas e utilizar a
              tecnologia como apoio ao gerenciamento e à execução das estratégias.
            </p>

            <p>
              Com diferentes robôs disponíveis, ampliamos as possibilidades de uso e permitimos
              que cada usuário monte uma estrutura mais alinhada ao seu perfil operacional.
            </p>
            </div>

            <div className="about-block">
            <h3>Por que isso é importante na prática?</h3>
            <p>
              Com a Quantum Trades, o trader não fica limitado a uma única lógica de operação.
              Cada robô possui uma proposta diferente, permitindo maior flexibilidade para testar
              cenários, diversificar estratégias e adaptar a automação conforme o mercado, o ativo
              e o perfil de risco.
            </p>
            <ul>
              <li>
                Utilizar diferentes abordagens operacionais.
              </li>
              <li>
                Diversificar estratégias entre robôs e ativos.
              </li>
              <li>
                Escolher entre soluções individuais ou pacote completo.
              </li>
              <li>
                Começar com uma configuração mais simples e evoluir com o tempo.
              </li>
              <li>
                Usar arquivos .set prontos como ponto de partida.
              </li>
              <li>
                Manter maior controle sobre risco, exposição e gerenciamento.
              </li>
            </ul>
            </div>

            <div className="about-block">
            <h3>Uma estrutura pensada para crescer com o trader</h3>
            <p>
              A Quantum Trades foi criada para acompanhar diferentes fases da jornada do usuário.
              Quem está começando pode utilizar configurações prontas e operar de forma mais
              simples. Já traders mais experientes podem explorar combinações entre robôs,
              ajustes personalizados, diferentes ativos e estratégias mais avançadas.
            </p>

            <p>
              A ideia é oferecer uma base tecnológica flexível, que possa evoluir junto com o
              trader e com suas necessidades operacionais.
            </p>
            </div>

            <div className="about-block">
            <h3>Em resumo</h3>
            <p>
              A Quantum Trades não é apenas um robô. É um ecossistema de automação para
              MetaTrader 5, com soluções diferentes, propostas complementares e maior liberdade
              para o usuário montar sua própria estrutura operacional.
            </p>

            <p>
              Mais opções, mais flexibilidade e mais organização para quem deseja operar com
              tecnologia, automação e controle no MT5.
            </p>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginTop: '30px' }}>
          <div className="col-sm-12 text-center">
            <h3>Escolha o robô ideal ou combine estratégias</h3>
            <p>
              Agora você pode contratar de forma individual ou montar um pacote com os 3 robôs,
              de acordo com a sua necessidade, seu capital e sua forma de operar.
            </p>
            <p>
              O objetivo é simples: oferecer mais possibilidades para que você monte uma operação
              mais inteligente, mais organizada e com maior potencial de diversificação.
            </p>
            {/* FIX: era <a to="/planos"> que não funciona — agora usa Link corretamente */}
            <Link to="/planos" className="btn btn-primary btn-lg">
              Ver planos e começar
            </Link>
          </div>
        </div>
      </div>

      <section className="platform-section">
        <div className="platform-inner">
          <img
            src={require('../img/MetaTrader5.png')}
            alt="MetaTrader 5"
            className="platform-logo"
          />
          <div>
            <h3>MetaTrader 5</h3>
            <p>
              Compatível com plataformas que utilizam o <strong>MetaTrader 5</strong>.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
